<div *ngIf="!isUpdate" [ngClass]="{'btn_only': !showText}"
  class="d-flex text-white py-3 text_1 alert_container justify-content-between align-items-center my-2">
  <ng-container *ngIf="showText">
    {{ "PROCESSES.ACCOMMODATION.ALERT.TITLE" | translate}}
  </ng-container>
  <div class="btn-gradiant-red">
    <button (click)="openModale(alert_modale)" class="btn d-flex flex-row gap-8 text-nowrap border-0" type="button">
      <lf-icon class="lh-1" height="16px" name="Notif" width="16px" *ngIf="showText"></lf-icon>
      <lf-icon class="lh-1" height="16px" name="NotifWhite" width="16px" *ngIf="!showText"></lf-icon>
      <span>{{ "PROCESSES.ACCOMMODATION.ALERT.BUTTON" | translate}}</span>
    </button>
  </div>

</div>


<ng-template #alert_modale let-modal>
  <div class="modal-container overflow-auto hidden-scrollbar p-4" [ngClass]="{'pb-0' :!isAlertCreated && isLogged }">

    <div class="d-flex justify-content-between pb-4 border-bottom mb-4 header_container">
      <h2 class="title_1 d-flex gap-16">
        <lf-icon class="lh-1" height="20px" name="Notif" width="20px"></lf-icon>
        {{ modaleTitle | translate }}
      </h2>
      <button (click)="modal.close()" aria-label="Close" class="btn border-0 m-0 ms-auto p-0" type="button">
        <span class="material-icons-outlined text-black">close</span>
      </button>
    </div>

    <!-- ----------------------------------- LOG IN FORM -------------------------------------------------------- -->
    <ng-container *ngIf="!isLogged; else loggedBlock">
      <app-form-login></app-form-login>
    </ng-container>

    <!-- ----------------------------------- CREATE ALERT -------------------------------------------------------- -->
    <ng-template #loggedBlock>
      <div *ngIf="!isAlertCreated">
        <!--   NOMMER L'ALERTE   -->
        <div class="mt-4 border-bottom pb-4">
          <h2 class="text_4 mb-3">{{'PROCESSES.ALERTS.ACCOMMODATION.FORM.NAME' |translate}}</h2>
          <mat-form-field class="pb-0 col-12 col-md-6">
            <input type="text" [placeholder]="'PROCESSES.ALERTS.ACCOMMODATION.PLACEHOLDER' | translate" matInput [formControl]="alertNameFormControl"/>
          </mat-form-field>
        </div>
        <!--   CONTENU DE L'ALERTE    -->
        <div class="mt-5 row m-0 p-0 pb-5">
          <h2 class="text_4 mb-3 ps-0">{{'PROCESSES.ALERTS.ACCOMMODATION.FORM.CITY' |translate}}</h2>
          <app-accommodation-city-input class="ps-0" [ngClass]="isMobile ? 'col-12' : 'col-8'" (hasChangedCity)="getCity($event)" [wantBtn]="false" [searchElement]="wantedCity && wantedCity.name ? wantedCity.name: wantedCity"></app-accommodation-city-input>
          <small class="text-danger minitext_1 px-0 pt-1" *ngIf="(!wantedCity || (wantedCity && wantedCity.name && wantedCity.name.length === 0)) && isSubmit">
            {{ "COMMON.IS_REQUIRED" | translate }}
          </small>
        </div>

        <app-filter-content type="alert" [filters]="alertFilters" (sendNewFilters)="getAlertFilters($event)"></app-filter-content>

        <!--   BOUTONS DE L'ALERTE - CREATION   -->
        <div class="mt-4 pt-4 pb-4 d-flex align-items-center gap-16 sticky-bottom bg-white w-124" [ngClass]="{'flex-wrap justify-content-between': isMobile}">
          <p class="minitext_3 w-100 text-center" *ngIf="isMobile"> {{'PROCESSES.ALERTS.ACCOMMODATION.FORM.LF_NOTIFY' |translate}}</p>
          <button type="reset" (click)="resetFilters()" class="btn btn-link mediumGray text_1 border-0">
            {{(isUpdate ? 'PROCESSES.ALERTS.PROFILE.BTN_RESET' : 'PROCESSES.ALERTS.ACCOMMODATION.FORM.RESET_BUTTON') |translate}}
          </button>
          <p class="ms-auto minitext_3" *ngIf="!isMobile"> {{'PROCESSES.ALERTS.ACCOMMODATION.FORM.LF_NOTIFY' |translate}}</p>
          <button type="submit" class="btn btn-gradient-blue" (click)="submit()">
            <ng-container *ngIf="!isSubmit">
              {{(isUpdate ? 'PROCESSES.ALERTS.PROFILE.BTN_CHANGE' : 'PROCESSES.ALERTS.ACCOMMODATION.FORM.SUBMIT_BUTTON') |translate}}
            </ng-container>
            <div *ngIf="isSubmit" class="spinner-border spinner-border-sm text-white my-1"></div>
          </button>
        </div>

      </div>

      <!-- ----------------------------------- ALERT SAVED -------------------------------------------------------- -->
      <div *ngIf="isAlertCreated">
        <p class="title_2 d-flex gap-16">
          {{'PROCESSES.ALERTS.ACCOMMODATION.VALIDATED.TEXT_1' |translate:{
          username: user.firstname,
          alertName: (alertNameFormControl.value ? alertNameFormControl.value : '')
        } }}
          <lf-icon class="lh-1" name="greenCheck" height="16px" width="16px"></lf-icon>
        </p>
        <p class="text_1">{{ 'PROCESSES.ALERTS.ACCOMMODATION.VALIDATED.TEXT_2' |translate }}</p>
        <div class="d-flex justify-content-end mt-3">
          <button type="button" (click)="goToProfile()" class="btn btn-gradient-blue">
            {{ 'PROCESSES.ALERTS.ACCOMMODATION.VALIDATED.BUTTON' |translate }}
          </button>
        </div>
      </div>

    </ng-template>


  </div>
</ng-template>
